import { createApp } from 'vue';
import ShareView from '../../../wealth/ShareView.vue'
const appElements = document.querySelectorAll('.vue-wealth-share-view')

Array.from(appElements).forEach(element => {
    createApp(ShareView).mount(element);
});